<ng-container>
  <button *ngFor="let item of items" 
      class="filter-check" 
      [value]="item.id"
      [ngClass]="{'is-active': isChecked(item)}" 
      (click)="selectItem(item)"
      [disabled]="disabled"
    >
    <span class="filter-check__icon">
      <img src="/Content/Images/icons/check.svg" width="12" height="8" *ngIf="isChecked(item)">
    </span>
    <span class="filter-check__text">{{ item.name }}</span>
  </button>
</ng-container>